import React from "react";

import { useFieldResourceStyles } from "../useFieldResourceStyles";
import FieldResourceCard from "./FieldResourceCard";
import {
  FieldResourceInformation,
  FieldResourceOption,
} from "../../../../types/CaseTypes";

interface FieldResourceListProps {
  fieldResources: FieldResourceInformation[];
  fieldResourceList: FieldResourceOption[];
}

const FieldResourceList: React.FC<FieldResourceListProps> = ({
  fieldResources,
  fieldResourceList,
}) => {
  const classes = useFieldResourceStyles();

  return (
    <div className={classes.fieldResourceContainer}>
      {fieldResources.map((fieldResource, index) => (
        <FieldResourceCard
          key={index}
          fieldResource={fieldResource}
          index={index}
          fieldResourceList={fieldResourceList}
        />
      ))}
    </div>
  );
};

export default FieldResourceList;
